// Copyright 2024, Imprivata, Inc.  All rights reserved.

import { useMutation } from '@tanstack/react-query';

import type { AppError } from '../../errorHandler/errors';
import { saveLegalDocumentLocations } from '../../api/portalServices';

export type ConsentLocationSaveType = {
  locations: string[];
};

function useConsentLocationSave() {
  return useMutation<void, AppError, ConsentLocationSaveType>({
    mutationFn: async ({ locations }) => {
        await saveLegalDocumentLocations(locations);
    },
    onError: (error) => {
      throw error;
    },
  });
}

export default useConsentLocationSave;
